import { IconAlertTriangle } from 'crm-core';
import React, { HTMLAttributes } from 'react';
import { Modal as BootstrapModal, Col, Row } from 'react-bootstrap';

import { Colors } from '../../utils';
declare const i18next: any;

export interface ModalProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  onClose?: () => void;
  footer?: React.ReactNode;
  show?: boolean;
  fullWidth?: boolean;
  scollable?: boolean;
  size?: 'lg' | 'sm' | 'default';
  statusColor?: Colors;
}

const Modal = ({
  children,
  title,
  footer,
  show,
  onClose,
  fullWidth,
  scollable,
  statusColor,
  size = 'default',
  ...props
}: ModalProps) => {
  return (
    <BootstrapModal
      {...props}
      show={show}
      onHide={onClose}
      scrollable={scollable}
      size={size === 'default' ? undefined : size}
      centered
      dialogClassName={`${fullWidth ? 'modal-full-width' : ''}`}
    >
      {statusColor && <div className={`modal-status z-3 bg-${statusColor}`}></div>}
      <div className="modal-content shadow-lg">
        <BootstrapModal.Header closeButton>
          {title && <BootstrapModal.Title>{title}</BootstrapModal.Title>}
        </BootstrapModal.Header>
        <BootstrapModal.Body>{children}</BootstrapModal.Body>
        {footer && <BootstrapModal.Footer>{footer}</BootstrapModal.Footer>}
      </div>
    </BootstrapModal>
  );
};

export interface AlertModalProps {
  title: string;
  message: string;
  cancelText?: string;
  okText?: string;
  onConfirm?: (ev: any) => void;
  onCancel?: (ev: any) => void;
}

export const AlertModal: React.FC<AlertModalProps & ModalProps> = ({
  title,
  message,
  cancelText,
  okText,
  onCancel,
  onConfirm,
  ...props
}) => {
  const footer = (
    <div className="w-100">
      <Row>
        <Col>
          <button className="btn w-100" onClick={onCancel}>
            {cancelText || i18next.t('CANCEL')}
          </button>
        </Col>
        <Col>
          <button className="btn btn-red w-100" onClick={onConfirm}>
            {okText || i18next.t('CONFIRM')}
          </button>
        </Col>
      </Row>
    </div>
  );

  return (
    <Modal {...props} title={title} footer={footer} statusColor="danger">
      <div className="text-center">
        <IconAlertTriangle size={60} className="text-red" strokeWidth={1} />
        <div className="text-muted mt-2">{message}</div>
      </div>
    </Modal>
  );
};

export const SuccessModal: React.FC<AlertModalProps & ModalProps> = ({
  title,
  message,
  cancelText,
  okText,
  onCancel,
  onConfirm,
  ...props
}) => {
  const footer = (
    <div className="w-100">
      <Row>
      <Col>
          <button className="btn w-100" onClick={onCancel}>
            {cancelText || i18next.t('CANCEL')}
          </button>
        </Col>
        <Col>
          <button className="btn btn-success w-100" onClick={onConfirm}>
            {okText || i18next.t('CONFIRM')}
          </button>
        </Col>
      </Row>
    </div>
  );

  return (
    <Modal {...props} title={title} footer={footer} statusColor="success">
      <div className="text-center">
        <i className="ti ti-circle-check-filled icon mb-2 text-green icon-lg" />
        <h3>{title}</h3>
        <div className="text-muted">{message}</div>
      </div>
    </Modal>
  );
};

export default Modal;
